import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '../actions/user'
import Vue from 'vue'
import {AUTH_ERROR, AUTH_LOGOUT, AUTH_SUCCESS} from '../actions/auth'
import axios from "axios";

const state = { status: '', profile: {access:[]} };

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name,
  canAccessThis: (state) => (accessId) =>{
    if (state.profile.access.indexOf('3') >= 0) {
      return true;
    }

    if (state.profile.access.indexOf(accessId) >= 0) {
      return true;
    }

    return false;
  },
};

const actions = {
  [USER_REQUEST]: ({commit, dispatch}) => {
    const send = {
      token:localStorage['user-token'],
      action:'User_GetInfo'
    };
    axios({
      method: 'post',
      url: process.env.VUE_APP_API_URL,
      data: send,
      responseType: 'json',
      headers: {'Content-type': 'application/json'}
    }).then(function(request){
      localStorage.setItem('UserID', request.data['Response']['ExecutionResult']['staff_id']);
      try {
        commit(USER_SUCCESS, request.data['Response']['ExecutionResult']);
      } catch (e) {
        commit(USER_ERROR);
        dispatch(AUTH_LOGOUT);
      }
    });
  },
};

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success';
    Vue.set(state, 'profile', resp)
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
}
